export default __webpack_public_path__ + "static/media/double-leaf.46941f94.svg";